<template>
  <div class="auth-card-wrapper">
    <div class="auth-card">
      <div class="auth-card-container">
        <img
          class="logo"
          alt="logo"
          src="@/assets/nubuilder.svg"
        />
        <h3 class="text-title mb-2">Reset password</h3>
        <p class="reset-password-description">If you have an account, you will receive a new registsration<br/>
          code by email that you can use to set a new password.
        </p>
      </div>

      <v-form ref="form" v-model="valid">
        <div class="auth-card-container form-fields" style="margin-bottom: 8px">
          <v-text-field
            label="Email"
            type="email"
            v-model="username"
            :rules="[rules.required, rules.email]"
            validate-on="blur"
            v-on:keydown.enter="submit"
            autofocus
            variant="outlined"
            density="default"
          ></v-text-field>

          <p class="message bg-error" v-html="error" v-if="error"/>
          <p class="message bg-indigo" v-html="message" v-if="message"/>

          <div class="d-flex justify-center auth-card-container">
            <v-btn rounded="lg" size="large" color="#363a40" class="d-flex" variant="flat" @click="submit"
                   tabindex="3">
              Request reset password
            </v-btn>
          </div>

          <v-divider></v-divider>

          <div class="auth-card-footer-part">
            <div class="auth-card-footer">
              <p class="text">
                No account?
                <router-link
                  class="text text-decoration-none"
                  tabindex="5"
                  :to="{ path: '/login'}"
                >
                  <span class="light--text">Login</span>
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      username: '',
      error: null,
      valid: true,
      message: null,
      rules: {
        required: (value) => !!value || 'Required.',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      }
    }
  },
  methods: {
    async submit (event) {
      event.preventDefault()
      const { valid } = await this.$refs.form.validate()
      if (valid) {
        this.$cognitoAuth.forgotPassword(this.username, (err, result) => {
          if (err) {
            this.error = err.message
          } else {
            this.$router.replace('/confirm-reset-password?username=' + this.username)
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.text {
  color: #1D1F22;
  font-size: 13px;
  text-align: left;
  margin-bottom: 0;
  line-height: 14.3px;
}

.logo {
  width: 110px;
  height: 48px;
  margin-bottom: 24px;
}

.form-fields {
  gap: 12px;
  display: flex;
  flex-direction: column;
}

.message {
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
</style>
